// Fix EC (2026-09-24): el mismo filtro de origen de Ejecución en Campo (Todos / Base /
// Adicional N, en el orden en que se anexaron), para Presupuesto, Centro de Costos,
// Consumo de Materiales, Tareas y el contrato con terceros.

export function opcionesOrigen(adicionalesIds, conTodos = true) {
  return [
    ...(conTodos ? [["todos", "Todos"]] : []),
    ["base", "Base"],
    ...(adicionalesIds || []).map((bid, i) => [bid, `Adicional ${i + 1}`]),
  ];
}

// Clave de origen de un ítem de la obra: "base" o el id del presupuesto adicional.
export function claveOrigen(item) {
  return item && item.origen_tipo === "adicional" && item.origen_budget_id ? item.origen_budget_id : "base";
}

export function etiquetaOrigen(item, adicionalesIds) {
  const clave = claveOrigen(item);
  if (clave === "base") return "Base";
  const i = (adicionalesIds || []).indexOf(clave);
  return `Adicional ${i >= 0 ? i + 1 : "?"}`;
}

export default function ChipsOrigen({ adicionalesIds, valor, onChange, conTodos = true, testId = "origen" }) {
  if (!(adicionalesIds || []).length) return null;
  return (
    <div className="flex gap-2 flex-wrap" data-testid={`${testId}-chips`}>
      {opcionesOrigen(adicionalesIds, conTodos).map(([key, label]) => (
        <button key={key} type="button" onClick={() => onChange(key)}
          className={`px-3 py-1.5 rounded-xl text-xs font-semibold transition-all border ${valor === key ? "bg-[#EA580C] text-white border-[#EA580C]" : "bg-white text-gray-600 border-gray-300 hover:border-[#EA580C]/40"}`}
          data-testid={`${testId}-chip-${key}`}>
          {label}
        </button>
      ))}
    </div>
  );
}
